import { SVLoader } from '@/components/core';
import DefaultLayout from '@/components/layouts/DefaultLayout';
import LendingAviationDetails from '@/components/lending/LendingAviationDetails';
import LendingHomeDetails from '@/components/lending/LendingHomeDetails';
import LendingYachtDetails from '@/components/lending/LendingYachtDetails';
import { useGetLendingDetails } from '@/hooks/requests/useLending';
import { Card, Typography } from '@mui/material';
import { useParams } from 'react-router-dom';

export default function LendingDetails() {
  const { uuid = '' } = useParams();
  const { loanRequest, isLoanRequestPending } = useGetLendingDetails(uuid);

  if (isLoanRequestPending) {
    return (
      <DefaultLayout header="Lending Request Details">
        <Card>
          <SVLoader />
        </Card>
      </DefaultLayout>
    );
  }

  if (!loanRequest) {
    return (
      <DefaultLayout header="Lending Request Details">
        <Card>
          <Typography>
            Something went wrong retreiving the lending request. Our team has
            been notified.
          </Typography>
        </Card>
      </DefaultLayout>
    );
  }

  return (
    <DefaultLayout header="Lending Request Details">
      {loanRequest.loanProduct === 'aviation' && (
        <LendingAviationDetails loanRequest={loanRequest} />
      )}
      {loanRequest.loanProduct === 'yacht' && (
        <LendingYachtDetails loanRequest={loanRequest} />
      )}
      {loanRequest.loanProduct === 'home' && (
        <LendingHomeDetails loanRequest={loanRequest} />
      )}
    </DefaultLayout>
  );
}
